import { deletebook } from "../actions";


export default function removeBook(bookId) {
    return async function(dispatch) {
        await fetch(`http://localhost:9000/books/${bookId}`, {
            method: "DELETE",
        });

        dispatch(deletebook(bookId));
    }
  
}
